import type { ServicePageConfig } from "../types";
import { bortforslingPages } from "./bortforsling";
import { tömningarPages } from "./tomningar";
import { flyttPages } from "./flytt";
import { transportPages } from "./transport";
import { barhjälpPages } from "./barhjalp";
import { hemleveransPages } from "./hemleverans";
import { budtjänstPages } from "./budtjanst";
import { möbelmonteringPages } from "./mobelmontering";
import { allCityPages } from "./cities";

export const allConfigPages: ServicePageConfig[] = [
  ...bortforslingPages,
  ...tömningarPages,
  ...flyttPages,
  ...transportPages,
  ...barhjälpPages,
  ...hemleveransPages,
  ...budtjänstPages,
  ...möbelmonteringPages,
  ...allCityPages,
];
